import React, { useState, useEffect, useRef } from "react";
import { connect } from "react-redux";
import SideBar from "../common/sideBar";
import {
  postServerDataWithPath,
  getServerDataWithTypes,
} from "../../../action/common_action";
import { axiosInstnace as Axios } from "../../../util/util";
import { endPoints } from "../../../config";
import NoData from "../common/NoData";
import Pagination from "../common/Pagination";
import moment from "moment";
import DatePicker from "react-datepicker";
import { history } from "../../../history/history";
import MessagePopup from "./MessagePopup";
import HeaderAdminpanel from "../common/HeaderAdminpanel";
const broadcastmanagement = (props) => {
  const [audiolist, handleAudioList] = useState([]);
  const [notifytype, handlenotifytype] = useState(undefined);
  const [campaignDetails, handleCampaignDetails] = useState({});
  const [showAudioBrief, handleShowAudioBrief] = useState(false);
  const [showExcelPopup, setShowHideExcelPopup] = useState(false);
  const message = useRef(undefined);
  const subject = useRef(undefined);
  const sentby = useRef(undefined)

  const [skip, handleSkip] = useState(0);
  const [count, handleCount] = useState(0);

  const [startDate, setStartDate] = useState(undefined);
  const [endDate, setEndDate] = useState(undefined);

  useEffect(() => {
    getAudiolist(0);
  }, []);

  const showHideExcelPopup = () => {
    setShowHideExcelPopup(!showExcelPopup);
  };

  //Get getAudiolist
  const getAudiolist = async (skip) => {
    console.log("Audoi management");
    let paramsConstrct;
    handleSkip(skip);
    try {
      paramsConstrct = {
          skip,
          message:message.current.value,
          subject: subject.current.value,
          notifytype,
          startDate,
          endDate,
          sentby: sentby.current.value
      };
      const data = await Axios.get(endPoints.getBroadCastHistory, {
        //  const data = await Axios.get(endPoints.getAudiolist,{
        params: paramsConstrct,
      });
      debugger;
      const result = data.data.data;
      console.log("audioaudioStatusStatus", result);
      if (result) {
        handleCount(data.data.data.count);
        handleAudioList(result);
      }
    } catch (error) {
      console.log(error);
    }
  };

  //Redirect to route bassed on path
  const goToRoute = (name, data, path) => {
    history.push(path, { [name]: data });
  };

  const clearSearch = () => {
    window.location.reload(true);
  };

  const showHideAudioBrief = (campaign) => {
    handleCampaignDetails(campaign);
    toggleAudioBrief();
  };

  const toggleAudioBrief = () => {
    handleShowAudioBrief(!showAudioBrief);
  };

  const callSearch = (e) => {
    e.preventDefault();
    getAudiolist(0);
  };

  //Return the t
  return (
    <div>
      <div className="dashboardContainer">
        <HeaderAdminpanel />
        <div className="dashboardContainer-inner">
          <section id="sidebar">
            <SideBar />
          </section>

          <section
            id="dashboard-rightContainer"
            className="dashboard-manageSales"
          >
            <div className="container-head">
              <div className="dashboard-breadcrumb">
                Notification Management |
                <span className="breadcrumb-active advertiser-breadcrumb">
                  Notification List
                </span>
              </div>
            </div>
            <form id="search-campaign-form" action="">
              <table cellPadding="10" cellSpacing="10" className="searchTable">
                <tbody>
                  <tr>
                    <td>
                      <div className="startDate">
                        <DatePicker
                          selected={startDate}
                          onChange={(date) => setStartDate(date)}
                          dateFormatCalendar={"MMM yyyy"}
                          placeholderText=" Start Date"
                          maxDate={endDate}
                          isClearable
                        />
                      </div>
                    </td>
                    <td>
                      <div className="endDate">
                        <DatePicker
                          selected={endDate}
                          onChange={(date) => setEndDate(date)}
                          dateFormatCalendar={"MMM yyyy"}
                          minDate={startDate}
                          placeholderText=" End date"
                          isClearable
                        />
                      </div>
                    </td>
                    <td>
                      <div className="drop">
                        <select
                          className="packageType drop-down-icon"
                          onChange={(event) =>
                            handlenotifytype(event.target.value)
                          }
                        >
                          <option value=""> Choose Notification Type</option>
                          <option value="sms"> SMS </option>
                          <option value="email">Email </option>
                        </select>
                      </div>
                    </td>
                    <td>
                      <div className="status-input search_camp search_list">
                        <input
                          type="text"
                          ref={subject}
                          placeholder="Subject"
                        />
                        <span>
                          <img src="/assets/images/search.png" />
                        </span>{" "}
                      </div>{" "}
                    </td>
                    <td>
                      <div className="status-input search_camp search_list">
                        <input
                          type="text"
                          ref={message}
                          placeholder="Message"
                        />
                        <span>
                          <img src="/assets/images/search.png" />
                        </span>{" "}
                      </div>{" "}
                    </td>
                  </tr>
                  <tr>
                  <td>
                      <div className="status-input search_camp search_list">
                        <input
                          type="text"
                          ref={sentby}
                          placeholder="Sent By"
                        />
                        <span>
                          <img src="/assets/images/search.png" />
                        </span>{" "}
                      </div>{" "}
                    </td>
                    <td>
                      <span className="print_btn">
                        <button onClick={callSearch}>Search</button>
                      </span>
                    </td>
                    <td>
                      <span className="print_btn mrgLft10px">
                        <button onClick={clearSearch}>Clear</button>
                      </span>
                    </td>
                    {/*<td>*/}
                    {/*    <span className="print_btn mrgLft10px">*/}
                    {/*        <button> Audio Download</button>*/}
                    {/*    </span>*/}
                    {/*</td>*/}
                  </tr>
                </tbody>
              </table>
            </form>

            <div
              className={
                audiolist.length === 0
                  ? "dashboard-content userListing-dashboard bg-white table-responsive none"
                  : "dashboard-content userListing-dashboard bg-white table-responsive"
              }
            >
              <table className="table table-striped master-table">
                <thead>
                  <tr>
                    {/*<th>Created Date</th>                                     */}
                    {/*<th>Created By</th>                                     */}
                    <th>Notification Type</th>
                    <th>Sent On</th>
                    <th>Sent By</th>
                    <th>Sent To</th>
                    <th>Subject</th>
                    <th>Message</th>
                  </tr>
                </thead>
                <tbody>
                  {audiolist.map((a, i) => (
                    <tr key={i}>
                      {/*<td>{a.createdBy}</td>*/}
                      <td>{a.subject ? "Email" : "SMS"}</td>
                      <td>{moment(a.senton).format("MMM Do YYYY HH:mm:ss")}</td>
                      <td>{a.sentBy}</td>
                      <td>{a.usernamelist && a.usernamelist.join(",")}</td>
                      <td>{a.subject ? a.subject : "-"}</td>
                      <td className="txt-cntr">
                        <a>
                          <span className="tooltip-reject view-tooltip">
                            {/*<img src="/assets/images/upload.png" className="upload-png reject-png" onClick={() => history.push('/admin/audioadminmanagment/UploadAudiolist',{a})}>*/}
                            <img
                              src="/assets/images/eye.png"
                              className="uploadaudiofile"
                              onClick={() => showHideAudioBrief(a)}
                            ></img>
                            <span>View</span>
                          </span>
                        </a>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
              <div className="paginationTable" />
              {(skip > 0 || count >= 10) && (
                <Pagination getAllData={getAudiolist} totalRecords={count} />
              )}
            </div>
            {audiolist.length === 0 ? <NoData /> : null}
          </section>
        </div>
      </div>
      {showAudioBrief && (
        <MessagePopup
          hideAudioBrief={toggleAudioBrief}
          campaignDetails={campaignDetails}
        />
      )}
    </div>
  );
};

const mapDispatchToProps = (dispatch) => {
  return {
    updateCampaign: (url, data, path) =>
      dispatch(postServerDataWithPath(url, data, path)),
  };
};
export default connect(null, mapDispatchToProps)(broadcastmanagement);



// WEBPACK FOOTER //
// ./web/components/admin/manageNotification/list.js